import React, { useState, useEffect } from 'react';
import SettingIcon from 'assets/icon/SettingIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import HalfStarIcon from 'assets/icon/HalfStarIcon';
import PackageIcon from 'assets/icon/PackageIcon';
import TransferIcon from 'assets/icon/TransferIcon';
import UserIcon from 'assets/icon/UserIcon';
import CategoryIcon from 'assets/icon/CategoryIcon';
import MenuIcon from 'assets/icon/MenuIcon';
import ExitIcon from 'assets/icon/ExitIcon';
import { SidebarCard } from 'components/Cards';
import CreditCardIcon from 'assets/icon/CreditCardIcon';

export default function Sidebar({ isOpen, toggleSidebar, onSidebarClick }) {
	const [isAdmin, setIsAdmin] = useState("0")
	
	const logoutBtnClick = () => {
		localStorage.removeItem("Token")
		localStorage.removeItem("Username")
		localStorage.removeItem("FirstName")
		localStorage.removeItem("LastName")
		localStorage.removeItem("Email")

		window.location.href = "/login"
	}

	useEffect(() => {
		setIsAdmin(localStorage.getItem("IsAdmin"))
	}, [])
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20 
			${ isOpen ? 'w-64' : 'hidden md:block sm:w-20' } `}
		>
			<div className={`h-screen flex flex-col gap-2 lg:text-base py-4 w-full`}>
				<div className={`hidden sm:flex gap-3 ${ isOpen ? 'justify-start' : 'justify-center' } px-4`}>
					<button className='block' onClick={toggleSidebar}>
						<MenuIcon className='fill-black w-5' />
					</button>
					{ isOpen && (
						<div className='flex justify-center w-full'>
							<span className={`font-semibold text-xl`}>Padel Port</span>
						</div>
					)}
				</div>

				<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto pt-5">
					<a className={`w-full py-3 cursor-pointer transition-all rounded-md flex items-center
							${ window.location.pathname === '/' ? 'font-bold' : '' } 
							${ isOpen ? 'px-4' : 'justify-center px-2' } 
						`}
						onClick={onSidebarClick}
						href="/"
					>
						<DashboardIcon className='w-5' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' } text-sm`}>Dashboard</p>
					</a>

					<div className={`${ isOpen ? 'block' : 'hidden' }`}>
						<span className='text-gray-400 text-sm'>Transaction</span>
					</div>
					
					<SidebarCard
						title='Transaksi Penjualan'
						path='/transaction-sales'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-5' />
					</SidebarCard>

					<SidebarCard
						title='Transaksi Rental'
						path='/transaction-rental'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-5' />
					</SidebarCard>

					<SidebarCard
						title='Pengeluaran'
						path='/expenses'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<CreditCardIcon className='w-5' />
					</SidebarCard>

					{/* <SidebarCard
						title='Sales Order'
						path='/sales-order'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Rental Order'
						path='/rental-order'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-6' />
					</SidebarCard> */}

					<SidebarCard
						title='Pelanggan'
						path='/customer'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<UserIcon className='w-5' />
					</SidebarCard>

					<div className={`${ isOpen ? 'block' : 'hidden' }`}>
						<span className='text-gray-400 text-sm'>Master Data</span>
					</div>

					<SidebarCard
						title='Stock Penjualan'
						path='/sales-stock'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-5' />
					</SidebarCard>

					<SidebarCard
						title='Stock Rental'
						path='/rental-stock'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-5' />
					</SidebarCard>

					<SidebarCard
						title='Product'
						path='/product'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-5' />
					</SidebarCard>
					
					<SidebarCard
						title='Brand'
						path='/brand'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<HalfStarIcon className='w-5' />
					</SidebarCard>

					<SidebarCard
						title='Category'
						path='/category'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<CategoryIcon className='w-5' />
					</SidebarCard>

					<div className={`
							${ isOpen ? 'block' : 'hidden' }
						`}>
						<span className='text-gray-400 text-sm'>Settings</span>
					</div>
					
					<SidebarCard
						title='Settings'
						path='/setting'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<SettingIcon className='w-5' />
					</SidebarCard>

					<button className='button flex justify-center mt-5 mb-5 w-full' onClick={logoutBtnClick}>
						{isOpen ? 
							<span className='text-sm'>Log Out</span> :
							<ExitIcon className='fill-white w-6 h-6' />
						}
					</button>
				</div>
			</div>	
		</div>
  	)
}
